import axios from "axios";

const isDev = process.env.NODE_ENV === "development";
const devApiBaseURL = process.env.VUE_APP_API_URL || "http://localhost:8080/api/";
export const apiBaseURL = isDev
  ? `${devApiBaseURL.replace(/\/+$/, "")}/`
  : "/extension2026/api/";

export const featureFlags = {
  enableLine: false,
  memberNotificationLoginPopupEnabled: false,
};

export const loadFeatureFlags = async () => {
  try {
    const response = await axios.get(`${apiBaseURL}web/feature-flags`, {
      withCredentials: true,
    });
    featureFlags.enableLine = !!response?.data?.enableLine;
    featureFlags.memberNotificationLoginPopupEnabled = !!response?.data?.memberNotificationLoginPopupEnabled;
  } catch (error) {
    featureFlags.enableLine = false;
    featureFlags.memberNotificationLoginPopupEnabled = false;
  }

  return featureFlags;
};

const Default = axios.create({
  baseURL: apiBaseURL,
  withCredentials: true,
});

const DefaultFile = axios.create({
  baseURL: apiBaseURL,
  withCredentials: true,
  responseType: "blob",
});

const attachMemberToken = (config) => {
    const token = localStorage.getItem("NewToken");

    if (token) {
      config.headers.Authorization = token;
    }

    return config;
};

Default.interceptors.request.use(
  attachMemberToken,
  (err) => Promise.reject(err),
);

DefaultFile.interceptors.request.use(
  attachMemberToken,
  (err) => Promise.reject(err),
);

Default.interceptors.response.use(
  (response) => response,
  (err) => {
    const silentErrorPaths = [
      "User/member/login",
      "User/member/2fa/verify-login",
      "User/member/register",
      "User/member/Activate",
      "User/member/ResetPasswordByToken",
      "User/member/ForgetPwd",
    ];
    const reqUrl = err?.config?.url || "";

    if (silentErrorPaths.some((path) => reqUrl.includes(path))) {
      return Promise.reject(err);
    }

    if (err.response?.data) {
      if (err.response.data.message) {
        alert(err.response.data.message);
      } else if (err.response.data.error) {
        alert(err.response.data.error);
      } else {
        alert(err.response.data);
      }
    }

    return Promise.reject(err);
  },
);

export const apiGetCourseAskUrl = () =>
  Default.get("Information/GetCourseAsk_url");

export const apiLogin = (data) => Default.post("User/member/login", data);
export const apiVerifyMemberTwoFactorLogin = (data) =>
  Default.post("User/member/2fa/verify-login", data);
export const apiResendMemberTwoFactorLogin = (data) =>
  Default.post("User/member/2fa/resend-login-otp", data);
export const apiRegister = (data) => Default.post("User/member/register", data);
export const apiActivateMember = (token) =>
  Default.post("User/member/Activate", { token });
export const apiCheckMember = () => Default.get("User/CheckMember");
export const apiGetMember = () => Default.get("User/Member");
export const apiPutMember = (data) => Default.put("User/Member", data);
export const apiResetPassword = (data) =>
  Default.put("User/Member/ResetPassword", data);

export const apiGetMemberLineBinding = () =>
  Default.get("User/member/line-binding");
export const apiCreateMemberLineBinding = (data) =>
  Default.post("User/member/line-binding", data);
export const apiCompleteMemberLineIdentity = (data) =>
  Default.post("User/member/line-binding/line-identity", data);
export const apiDeleteMemberLineBinding = () =>
  Default.delete("User/member/line-binding");

export const apiRequestPasswordReset = (data) =>
  Default.post("User/member/ForgetPwd", data);

export const apiResetPasswordByToken = (data) =>
  Default.post("User/member/ResetPasswordByToken", data);

export const apiAddCart = (id, data) => Default.post(`Cart/${id}`, data);
export const apiGetCart = () => Default.get("Cart/");
export const apiToCheckOut = (id) => Default.get(`CheckOut/${id}`);
export const apiToOrder = (data) => Default.post("CheckOut/", data);
export const apiDeleteCart = (id) => Default.delete(`CheckOut/${id}`);

export const apiOrderList = (data) => Default.post("Order/member/List", data);
export const apiFavoriteProductList = (data) =>
  Default.post("FavoriteProduct/List", data);
export const apiFavoriteProductInsert = (productId) =>
  Default.post(`FavoriteProduct/${encodeURIComponent(productId)}`);
export const apiFavoriteProductDelete = (productId) =>
  Default.delete(`FavoriteProduct/${encodeURIComponent(productId)}`);
export const apiOrderDetailList = (data) =>
  Default.post("OrderDetail/member", data);
export const apiCampOrderDetailList = (data) =>
  Default.post("CampOrderDetail/member", data);
export const apiCampRegistrantDetail = (orderDetailId) =>
  Default.get(`CampOrderDetail/member/${orderDetailId}`);
export const apiCampRegistrantUpdate = (orderDetailId, data) =>
  Default.put(`CampOrderDetail/member/Registrant/${orderDetailId}`, data);
export const apiCampRegistrationCancel = (orderDetailId, data) =>
  Default.put(`CampOrderDetail/member/Cancel/${orderDetailId}`, data);
export const apiCampOrderList = (data) =>
  Default.post("CampOrder/member/List", data);
export const apiCampOrderDetail = (id) =>
  Default.get(`CampOrder/member/${id}`);
export const apiCampOrderPaymentHistory = (id) =>
  Default.get(`CampOrder/member/Payments/${id}`);
export const apiCampOrderHasUnpaid = () =>
  Default.get("CampOrder/member/HasUnpaid");
export const apiGetMemberNotificationList = (data) =>
  Default.post("member/notification/list", data);
export const apiGetMemberNotification = (id) =>
  Default.get(`member/notification/${id}`);
export const apiGetMemberNotificationUnreadCount = () =>
  Default.get("member/notification/unread-count");
export const apiGetMemberNotificationSummary = () =>
  Default.get("member/notification/summary");
export const apiReadMemberNotification = (id) =>
  Default.post(`member/notification/read/${id}`);
export const apiReadMemberNotifications = (notificationIds) =>
  Default.post("member/notification/read-batch", { NotificationIds: notificationIds });
export const apiReadAllMemberNotifications = () =>
  Default.post("member/notification/read-all");
export const apiDownloadMemberNotificationAttachment = (id) =>
  DefaultFile.get(`member/notification/attachment/download/${id}`);
export const apiCampOrderCancel = (id, data) =>
  Default.put(`CampOrder/member/Cancel/${encodeURIComponent(id)}`, data);
export const apiCampPaymentList = () =>
  Default.get("CampPayment/member/List");
export const apiCampPaymentGet = (id) =>
  Default.get(`CampPayment/member/${encodeURIComponent(id)}`);
export const apiCampPaymentReport = (id, data) =>
  Default.put(`CampPayment/member/${encodeURIComponent(id)}`, data);
export const apiCampPaymentCancel = (id, data) =>
  Default.put(`CampPayment/member/Cancel/${encodeURIComponent(id)}`, data);
export const apiCampPaymentRetry = (campOrderId, data) =>
  Default.post(`CampPayment/member/Retry/${encodeURIComponent(campOrderId)}`, data);
export const apiCampPaymentProofUpload = (id, formData) =>
  Default.post(
    `CampPayment/member/${encodeURIComponent(id)}/ProofImage`,
    formData,
  );
export const apiCampPaymentProofImage = (id) =>
  Default.get(`CampPayment/member/${encodeURIComponent(id)}/ProofImage`, {
    responseType: "blob",
  });
export const apiCampRefundList = () =>
  Default.get("CampRefund/member/List");
export const apiCampRefundGet = (id) =>
  Default.get(`CampRefund/member/${encodeURIComponent(id)}`);
export const apiCampRefundApplyOrder = (campOrderId, data) =>
  Default.post(`CampRefund/member/Orders/${encodeURIComponent(campOrderId)}/Apply`, data);
export const apiCampRefundApplyDetail = (campOrderDetailId, data) =>
  Default.post(`CampRefund/member/Details/${encodeURIComponent(campOrderDetailId)}/Apply`, data);
export const apiCampRefundWithdraw = (id, data) =>
  Default.post(`CampRefund/member/${encodeURIComponent(id)}/Withdraw`, data);
export const apiCampRefundAccount = (id, data) =>
  Default.post(`CampRefund/member/${encodeURIComponent(id)}/RefundAccount`, data);
export const apiCampRefundProofUpload = (id, formData) =>
  Default.post(`CampRefund/member/${encodeURIComponent(id)}/RefundAccountProofImage`, formData);
export const apiCampRefundProofImage = (id) =>
  Default.get(`CampRefund/member/${encodeURIComponent(id)}/RefundAccountProofImage`, {
    responseType: "blob",
  });

export const apiGetCampCoupons = () => Default.get("member/CampCoupon");
export const apiReceiveCampCoupon = (data) => Default.post("member/CampCoupon/Receive", data);
export const apiOrderDetail = (data) =>
  Default.get(`OrderDetail/member/${data}`);
export const apiOrderDetailTransfer = (data) =>
  Default.put("OrderDetail/member", data);

export const apiDictionary = (category, type) =>
  Default.get(`Dictionary/View/${category}/${type}`);
export const apiDictionarySeries = (category, type) =>
  Default.get(`Dictionary/View/${category}/${type}`);
export const apiDictionaryList = (data) =>
  Default.post("Dictionary/View", data);
export const apiDictionarySelector = (id) =>
  Default.get(`Dictionary/Selector/${encodeURIComponent(id)}`);

export const apiCourseList = (data) => Default.post("Course/View/list", data);
export const apiNewCourseList = (data) =>
  Default.post("Course/newCourseList", data);
export const apiGetCourse = (data) => Default.get(`Course/View/${data}`);
export const apiGetCourseSeries = (data) =>
  Default.get(`Course/View/Series/${data}`);
export const apiGetCourseAttachments = (classId) =>
  Default.get(`web/course/attachments/${encodeURIComponent(classId)}`);
export const apiDownloadCourseAttachment = (fileId) =>
  DefaultFile.get(
    `web/course/attachment/download/${encodeURIComponent(fileId)}`,
  );
export const apiGetHotTags = () => Default.get("Tag/Hot");

export const apiGetInformation = (data) =>
  Default.get(`Information/GetByType/${data}`);
export const apiGetInfo = () => Default.get("Information/footer_info_views/");

export const apiGetPhoto = (data) => Default.post("Photo/View/List", data);
export const apiGetCampPhoto = (data) => Default.post("Photo/Camp/View/List", data);
export const apiGetNewsList = (data) => Default.post("News/View/List", data);
export const apiGetNews = (data) => Default.get(`News/View/${data}`);
export const apiGetFaq = (data) => Default.post("Faq/View/List", data);
export const apiGetQuestion = (data) =>
  Default.get(`Questionnaire/Title/${data}`);
export const apiSaveQuestion = (data) =>
  Default.post("Questionnaire/Save/", data);
export const apiGetCityTown = (data) => Default.post("City/List", data);

export const apiGetCampSeries = (data = {}) => Default.post("Camp/Series", data);
export const apiGetCampSeriesTypeSelector = () =>
  Default.get("Camp/Series/Type/Selector");
export const apiGetCampSeasonTypeSelector = () =>
  Default.get("Camp/Dictionary/Selector/camp/season_type");
export const apiGetCampSeriesPrograms = (id) =>
  Default.get(`Camp/Series/${encodeURIComponent(id)}`);
export const apiGetCampSeriesProgramList = (id, data) =>
  Default.post(`Camp/Series/Programs/List/${encodeURIComponent(id)}`, data);
export const apiGetCampOverviewList = (data) =>
  Default.post("Camp/Series/Overview/List", data);
export const apiGetCampProgram = (id) =>
  Default.get(`Camp/Program/${encodeURIComponent(id)}`);
export const apiGetCampProgramAttachments = (id) =>
  Default.get(`Camp/Program/Attachments/${encodeURIComponent(id)}`);
export const apiDownloadCampProgramAttachment = (fileId) =>
  DefaultFile.get(
    `Camp/Program/Attachment/Download/${encodeURIComponent(fileId)}`,
  );
export const apiGetCampProductSchedules = (id) =>
  Default.get(`Camp/Product/Schedules/${encodeURIComponent(id)}`);

// 營隊購物車
export const apiGetCampCart = () => Default.get("CampCart");
export const apiGetCampCartAddonOptions = () => Default.get("CampCart/addon-options");
export const apiAddCampCartAddon = (data) => Default.post("CampCart/addon", data);
export const apiAddCampCartBatch = (campProductId, relationIds) => Default.post(`CampCart/${campProductId}`, relationIds);
export const apiDeleteCampCart = (id) => Default.delete(`CampCart/${id}`);

// 營隊結帳
export const apiGetCampCheckout = () => Default.get("CampCheckout");
export const apiPreviewCampCheckout = (data) => Default.post("CampCheckout/Preview", data);
export const apiPostCampCheckout = (data) => Default.post("CampCheckout", data);

// 關係人
export const apiGetUserRelationList = (data) => Default.post("UserRelation/List", data);
export const apiGetUserRelation = (id) => Default.get(`userrelation/${id}`);
export const apiCreateUserRelation = (data) => Default.post("userrelation", data);
export const apiUpdateUserRelation = (data) => Default.put("userrelation", data);
export const apiRemoveUserRelation = (id) => Default.put(`UserRelation/Removed/${id}`);

export const apiGetCaptcha = () =>
  DefaultFile.get("Captcha", {
    params: { t: Date.now() },
    headers: {
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
    },
  });
